import uuid from 'uuid/v1';

export default [
  {
    id: '1',
    date_create: '1399/5/1',
    city: "میبد",
    bar:'سرامیک',
    weight:'0',
    car:'بنز تک',
    number:'20'
  },  {
    id: '2',
    date_create: '1399/5/1',
    city: "کرج",
    bar:'آجر',
    weight:'200',
    car:'اسکانیا دو لبه',
    number:'1'
  },
 
];
